// extracted by mini-css-extract-plugin
export default {"container":"duplicate-vasuli_container__6+eAI","message":"duplicate-vasuli_message__Wzo0m","footer":"duplicate-vasuli_footer__YiSUn"};